import { toLatLngLiteral } from "common/geoBoundaryUtils"

export const getPathsCentroidLiteral = paths => {
  if (!paths?.length) return null

  let latSum = 0
  let lngSum = 0
  let count = 0

  paths.forEach(point => {
    const literal = toLatLngLiteral(point)
    if (!literal) return
    latSum += literal.lat
    lngSum += literal.lng
    count += 1
  })

  if (!count) return null
  return { lat: latSum / count, lng: lngSum / count }
}

let ZoneMapLabelOverlayClass = null

const getZoneMapLabelOverlayClass = () => {
  if (ZoneMapLabelOverlayClass || !window.google?.maps) {
    return ZoneMapLabelOverlayClass
  }

  ZoneMapLabelOverlayClass = class extends window.google.maps.OverlayView {
    constructor(position, text, accentColor) {
      super()
      this.position = position
      this.text = text
      this.accentColor = accentColor
      this.div = null
    }

    onAdd() {
      this.div = document.createElement("div")
      this.div.textContent = this.text
      Object.assign(this.div.style, {
        position: "absolute",
        transform: "translate(-50%, -50%)",
        background: "rgba(255, 255, 255, 0.96)",
        color: "#111827",
        fontSize: "13px",
        fontWeight: "700",
        padding: "6px 12px",
        borderRadius: "999px",
        border: `2px solid ${this.accentColor}`,
        boxShadow: "0 2px 10px rgba(15, 23, 42, 0.28)",
        whiteSpace: "nowrap",
        pointerEvents: "none",
        lineHeight: "1.2",
        letterSpacing: "0.01em",
        maxWidth: "220px",
        overflow: "hidden",
        textOverflow: "ellipsis",
      })

      this.getPanes().floatPane.appendChild(this.div)
    }

    draw() {
      if (!this.div) return

      const projection = this.getProjection()
      if (!projection) return

      const point = projection.fromLatLngToDivPixel(
        new window.google.maps.LatLng(this.position.lat, this.position.lng)
      )
      if (!point) return

      this.div.style.left = `${point.x}px`
      this.div.style.top = `${point.y}px`
    }

    onRemove() {
      if (this.div?.parentNode) {
        this.div.parentNode.removeChild(this.div)
      }
      this.div = null
    }
  }

  return ZoneMapLabelOverlayClass
}

export const createZoneMapLabelOverlay = (
  map,
  position,
  label,
  accentColor = "#1976d2"
) => {
  const text = String(label || "").trim()
  const OverlayClass = getZoneMapLabelOverlayClass()
  if (!map || !text || !position || !OverlayClass) return null

  const overlay = new OverlayClass(position, text, accentColor)
  overlay.setMap(map)
  return overlay
}

export const createZoneMapLabelOverlayFromPaths = (
  map,
  paths,
  label,
  accentColor = "#1976d2"
) => {
  const position = getPathsCentroidLiteral(paths)
  if (!position) return null
  return createZoneMapLabelOverlay(map, position, label, accentColor)
}

export const removeZoneMapLabelOverlays = overlays => {
  overlays.forEach(overlay => overlay?.setMap(null))
}
